import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoSwiperLR, { EcoSwiperLRItemProps } from 'eco-design/sections/eco-swiper-l-r';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import { getImgUrl } from '../../utils';

export default function Comp() {
    const { t } = useLang('theProduct.SectionE');
    const { locale = 'us' } = getLocal();
    const IS_JP_SITE = ['jp'].includes(locale);

    const item1 = {
        jp: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745379706309/E1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745379705830/E1-h5.jpg',
        },
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744598846155/E1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744598845745/E1-h5.jpg',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744598846155/E1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744598845745/E1-h5.jpg',
        },
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722608152/UK.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722608626/UK-image.jpg',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722608152/UK.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722608626/UK-image.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722609770/DE.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722607885/DE-image.jpg',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722609091/FR.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722608400/FR-image.jpg',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1746587872798/it.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1746587872625/it-h5.jpg',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1746587873173/es.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1746587871914/es-h5.jpg',
        },
        au: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745722608152/UK.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745722608626/UK-image.jpg',
        },
    };

    const items: EcoSwiperLRItemProps[] = [
        getImgUrl(item1),
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379705938/E2.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744598846382/E2.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745379706488/E2-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744598845894/E2-h5.jpg',
        },
    ];
    return (
        <div className={styles.comp} id="SectionE">
            <EcoSpace />
            <EcoSectionCommon className={styles.section} label={t('label')} title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <EcoSwiperLR items={items} />
            <EcoSpace />
        </div>
    );
}
